import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textNormalize'
})
export class TextNormalizePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const text = `${value || ''}`;
    return text
      .replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec))
      .replace(/(&.+;)/ig, (match, dec) => String.fromCharCode(match.charCodeAt(0)));
  }

}
